import React, { useEffect } from "react";
import "./Career.css";
import { FaHeadset, FaBriefcase, FaChartLine } from "react-icons/fa";

const Career = () => {
  const roles = [
    { title: "Flutter Developer", type: "onsite", mode: "fulltime" },
    { title: "UI/UX Designer", type: "onsite", mode: "fulltime" },
    { title: "Graphic Designer", type: "onsite", mode: "fulltime" },
    { title: "Project Coordinator", type: "onsite", mode: "fulltime" },
    { title: "Business Developer", type: "onsite", mode: "fulltime" },
    { title: "HR (Human Resources)", type: "onsite", mode: "fulltime" },
  ];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="career">
      <div className="career_container">
        <h5>We have been waiting for you</h5>
        <p style={{ maxWidth: "800px" }}>
          Your career is a journey of growth, discovery, and endless
          possibilities. Embrace the path that leads you to your true potential.
        </p>
        <div className="contact-grid">
          <div className="contact-card primary-card">
            <div className="contact-icon">
              <FaBriefcase />
            </div>
            <div className="contact-info">
              <h6>Career & HR Enquiry</h6>
              <a href="tel:+917306431306" className="aTag">
                +91 73064 31306
              </a>
              <a href="mailto:career@spinecodes.com" className="emailTag">
                career@spinecodes.com
              </a>
            </div>
          </div>

          <div className="contact-card">
            <div className="contact-icon">
              <FaHeadset />
            </div>
            <div className="contact-info">
              <h6>General & Sales Enquiry</h6>
              <a href="tel:+918547274065" className="aTag">
                +91 85472 74065
              </a>
              <a href="mailto:info@spinecodes.com" className="emailTag">
                info@spinecodes.com
              </a>
            </div>
          </div>
        </div>
      </div>
      <div>
        <h1 className="current-opening">Current Openings</h1>
        <ul className="career_roles">
          {roles.map((role, index) => (
            <li key={index}>
              <h1>{role.title}</h1>
              <div>
                <h2>
                  {role.type}&nbsp;&nbsp;•&nbsp;&nbsp;{role.mode}
                </h2>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default Career;

//   const templatId = "template_8472y79"

//   const serviceId = ""

//   const UserId = ""

//     const [file, setFile] = useState(null);

//     const handleFileChange = (e) => {
//       setFile(e.target.files[0]);
//     };

//     const handleSubmit = (e) => {
//       e.preventDefault();

//       // You would typically send the file to the server or use an email service like EmailJS
//       if (file) {
//         // Handle file upload logic here
//         console.log('CV Uploaded:', file.name);
//         alert(`Your CV (${file.name}) has been submitted successfully!`);
//       } else {
//         alert('Please upload your CV.');
//       }
//     };
